// extracted by mini-css-extract-plugin
export default {"text":"Error_text__snmAG"};